/* Theme-only enhancements; jQuery and plugins load in order with defer. */
(function (window, document) {
  'use strict';
  function releaseReady(){
    if(window.WOThemeJQueryHeld && window.jQuery){ window.WOThemeJQueryHeld=false; window.jQuery.holdReady(false); }
  }
  if(document.readyState==='complete')releaseReady();else document.addEventListener('DOMContentLoaded',releaseReady,{once:true});
  var returnFocus;
  document.addEventListener('click', function(event) {
    var opener=event.target.closest('[data-wo-open-purchase]');
    var closer=event.target.closest('[data-wo-close-purchase]');
    if(opener){
      var dialog=document.getElementById(opener.getAttribute('aria-controls'));
      if(!dialog)return;
      event.preventDefault();returnFocus=opener;
      if(dialog.showModal)dialog.showModal();else dialog.setAttribute('open','');
      var focus=dialog.querySelector('button,select,input:not([type=hidden])');
      if(focus)focus.focus();
    } else if(closer || event.target.matches('dialog.wo-purchase-dialog')){
      var active=closer?closer.closest('dialog'):event.target;
      if(!closer){
        var bounds=active.getBoundingClientRect();
        if(event.clientX>=bounds.left && event.clientX<=bounds.right && event.clientY>=bounds.top && event.clientY<=bounds.bottom)return;
      }
      if(active.close)active.close();else active.removeAttribute('open');
      if(returnFocus)returnFocus.focus();
    }
  });
})(window,document);
